module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_163559_HDR-removebg-preview-81ef82f742e428b7b7172dd76fb172ea.png";